/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { AppointmentStatusDetail } from '../../../interfaces/patient-services/appointment-status-detail';

@Injectable()
export class ApptStatusDetailApi {

 // private readonly apiController: string = 'tenants/';

  constructor(private api: HttpService) { }


 

  getById(url: string, options?: any): Observable<AppointmentStatusDetail> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept', 'application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url, header);
  }

  add(url: string, data: AppointmentStatusDetail): Observable<AppointmentStatusDetail> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept', 'application/vnd.ezovion.hateoas+json');
    return this.api.directPost(url, data, header);
  }

}
